module.exports = __webpack_public_path__ + "media/images/flags/32/Cook-Islands-ee207951a9dbfc0304e2c600f8a83aa5.png";